/* eslint-disable @next/next/no-img-element */
"use client";
import React, { useEffect, useState } from "react";
import { Carousel } from "@arco-design/web-react";
import { ResponseData, THomeBannerInfo } from "@/typings";
import { AdvBannerType } from "@/shared";
import "./index.scss";
import { useHomeBanner } from "@/api/home/use-query";
interface BannerPageProps {
  aboutBanners?: ResponseData<THomeBannerInfo[]>;
}
const BannerPage: React.FC<BannerPageProps> = ({ aboutBanners }) => {
  const [banners, setBannersData] = useState(aboutBanners?.data || []);
  const { mutate: fetchHomeBanner, data: bannerList } = useHomeBanner();
  useEffect(() => {
    if (!aboutBanners?.data) {
      fetchHomeBanner({
        params: { banner_type: AdvBannerType.About },
      });
    }
  }, [aboutBanners, fetchHomeBanner]);

  useEffect(() => {
    if (bannerList) {
      setBannersData(bannerList.data);
    }
  }, [bannerList]);
  return (
    <Carousel
      autoPlay={{ interval: 3000 }}
      showArrow="never"
      indicatorType="line"
      className={"min-h-96 yf-about-us-banner"}
    >
      {banners.map((item, index) => (
        <div key={index}>
          <img
            src={item.pic_url}
            className={"w-full h-full"}
            alt=""
            width={0}
            height={0}
          />
        </div>
      ))}
    </Carousel>
  );
};

export default BannerPage;
